export const scaledContainerId = '#scaled-container';
export const zoomContainerId = '#zoom-container';

export const zoom = (element, zoom) => {
    let scale = '';
    let height = '';
    const $scaledContainer = $(element.contentDocument).find(scaledContainerId);

    if (zoom === 'fit') {
        height = '100vh';

        scale = Math.min(
            element.clientWidth / $scaledContainer.width(),
            element.clientHeight / $scaledContainer.height()
        );
    }
    
    if (zoom === 'fill') {
        scale = (element.clientWidth / $scaledContainer.width()) - 0.09;
        height = $scaledContainer.height() * scale + 'px';
    }

    if (zoom == '') {
        height = '';
        scale = 1;
    }

    $scaledContainer.css("transform", `scale(${scale})`);
    $(element.contentDocument).find(zoomContainerId).css("height", height);
}

export const createZoomWrapper = (content) => {
    return `
        <div id="zoom-container" style="display: flex; align-items: center; justify-content: center;">
            <div id="scaled-container" style="transform: scale(1.0);">
                ${content}
            </div>
        </div>
    `;
}

export const getZoomWrapperContents = (content) => {
    const html = (new DOMParser()).parseFromString(content, "text/html");
    const scaleContainer = html.querySelector(scaledContainerId);
    
    if (!scaleContainer) {
        return content;
    }

    return scaleContainer.innerHTML;
}